import events from '../events.yaml';
import { createTracker } from 'usage-tracker';
export const tracker = createTracker({
  events,
  properties: {
    namespace: 'trial-components-library'
  }
});
export const trackInteraction = (action, properties) => tracker.track('interaction', Object.assign({
  action
}, properties));